import i18n from '@/plugins/i18n';

export default function (value, keyBase = '') {
  if (!value) return '';
  if (i18n.te(`${keyBase}.${value}`)) return i18n.t(`${keyBase}.${value}`);
  return value;
}
